import classNames from "classnames";
// React
import React from "react";
import { List } from "react-virtualized";
// Redux
import { connect } from "react-redux";
import { Link } from 'react-router';
// Utils
import * as AppRouting from "appRouting";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./OfficeSearch.less";
const mapStateToProps = (state) => ({
    user: state.user
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class OfficeSearch extends React.Component {
    constructor(props) {
        super(props);
        this.rowRenderer = this.rowRenderer.bind(this);
        this.noRowsRenderer = this.noRowsRenderer.bind(this);
        let filterText = this.props.agencyName ? this.props.agencyName : "";
        filterText = this.props.officeName ? filterText + " " + this.props.officeName : filterText;
        this.state = { filterText: filterText, filteredResults: [], scrollToIndex: null };
    }
    componentDidMount() {
        this.filterResults("");
        this.scrollToIndexOf(this.state.filterText);
    }
    noRowsRenderer() {
        return (React.createElement("div", { className: styles.noSearchResults },
            React.createElement("span", null, "No results match the filter")));
    }
    ifOfficeActiveClassName(userAccess) {
        if (this.props.officeId && userAccess.office && userAccess.id == this.props.officeId) {
            return styles.resultActive;
        }
        return "";
    }
    ifAgencyActiveClassName(userAccess) {
        if (this.props.agencyId && userAccess.agency && userAccess.id == this.props.agencyId) {
            return styles.resultActive;
        }
        return "";
    }
    rowRenderer(props) {
        const { index, style } = props;
        const userAccess = this.state.filteredResults[index];
        if (userAccess) {
            if (userAccess.office) {
                return (React.createElement("div", { key: `Office${userAccess.id}`, className: classNames(styles.resultContainer, styles.resultContainerOffice, this.ifOfficeActiveClassName(userAccess)), style: style },
                    React.createElement(Link, { onClick: () => this.props.onSelectCallback(), to: AppRouting.officeUrl(userAccess.id), className: classNames(styles.result), activeClassName: "active" },
                        React.createElement("span", { className: styles.agencyName }, userAccess.agency),
                        React.createElement("span", { className: styles.officeName }, userAccess.office))));
            }
            else { //if (userAccess.agency) {
                return (React.createElement("div", { key: `Agency${userAccess.id}`, className: classNames(styles.resultContainer, styles.resultContainerAgency, this.ifAgencyActiveClassName(userAccess)), style: style },
                    React.createElement(Link, { onClick: () => this.props.onSelectCallback(), to: AppRouting.agencyUrl(userAccess.id), className: classNames(styles.result), activeClassName: "active" },
                        React.createElement("span", { className: classNames(styles.resultLabel) }, "Group-Level Reporting"),
                        React.createElement("span", { className: styles.agencyName }, userAccess.agency))));
            }
        }
        else {
            return React.createElement("span", null, "No Data");
        }
    }
    textIncludesAny(text, keywords) {
        let includes = true;
        for (let i = 0; i < keywords.length; i++) {
            includes = includes && text.includes(keywords[i]);
        }
        return includes;
    }
    filterResults(value) {
        let userAccess = this.props.user.userAccess;
        if (!value || value == "") {
            this.setState({ filterText: value, filteredResults: userAccess, scrollToIndex: 0 });
        }
        else {
            const keywords = value.toLowerCase().split(" ");
            const filtered = userAccess.filter((access) => {
                const agencyName = access.agency ? access.agency.toLowerCase() : "";
                const officeName = access.office ? access.office.toLowerCase() : "";
                let fullName = `${agencyName}`;
                if (officeName) {
                    fullName = `${fullName} ${officeName}`;
                }
                return this.textIncludesAny(fullName, keywords);
            });
            this.setState({ filterText: value, filteredResults: filtered, scrollToIndex: 0 });
        }
    }
    scrollToIndexOf(value) {
        const userAccess = this.props.user.userAccess;
        if (!value || value == "") {
            this.setState({ filterText: this.state.filterText, filteredResults: userAccess, scrollToIndex: 0 });
        }
        else {
            let index = userAccess.findIndex((access) => {
                const agencyName = access.agency ? access.agency.toLowerCase() : "";
                const officeName = access.office ? access.office.toLowerCase() : "";
                let fullName = `${agencyName}`;
                if (officeName) {
                    fullName = `${fullName} ${officeName}`;
                }
                return fullName == value.toLowerCase();
            });
            index = Math.max(0, index - 1);
            this.setState({ filterText: this.state.filterText, filteredResults: userAccess, scrollToIndex: index });
        }
    }
    renderClearButton() {
        if (!this.state.filterText || this.state.filterText == "") {
            return React.createElement("span", null);
        }
        return (React.createElement("span", { className: "fa fa-close", onClick: () => {
                this.setState({ filterText: "", filteredResults: this.props.user.userAccess, scrollToIndex: 0 });
                const input = this.refs["officeSearchInput"];
                input.focus();
            } }));
    }
    renderSearch(showSearch) {
        if (showSearch) {
            return (React.createElement("div", { className: styles.inputContainer },
                React.createElement("input", { className: "form-control", type: "text", placeholder: "Filter by name...", value: this.state.filterText, onChange: (event) => this.filterResults(event.target.value), ref: "officeSearchInput" }),
                this.renderClearButton()));
        }
        else {
            return React.createElement("div", null);
        }
    }
    renderContents(hasResults) {
        if (hasResults) {
            return (React.createElement("div", { onWheel: (e) => e.stopPropagation() },
                React.createElement(List, { width: 240, height: 350, rowHeight: 50, rowCount: this.state.filteredResults.length, rowRenderer: this.rowRenderer, noRowsRenderer: this.noRowsRenderer, overscanRowCount: 0, scrollToIndex: this.state.scrollToIndex, scrollToAlignment: "auto" })));
        }
        else {
            return React.createElement("div", { className: styles.noSearchResults },
                React.createElement("span", null, "No results match the filter"));
        }
    }
    render() {
        let { user } = this.props;
        if (!user || !user.userAccess) {
            return React.createElement("div", null);
        }
        if (user.userAccess.length === 0) {
            return (React.createElement("div", { className: styles.dropdownInner },
                React.createElement("div", { className: styles.noSearchResults },
                    React.createElement("span", null,
                        React.createElement("p", null, "You are not associated with any offices or agencies."),
                        React.createElement("p", null,
                            "You can contact our support centre on ",
                            React.createElement("a", { href: `mailto:${callCentreEmail}` }, callCentreEmail),
                            " or ",
                            React.createElement("a", { href: `tel:${callCentreNumber}` }, callCentreNumberText))))));
        }
        return (React.createElement("div", { className: styles.dropdownInner },
            this.renderSearch(user.userAccess.length > 6),
            this.renderContents(this.state.filteredResults.length > 0)));
    }
}
export default connect(mapStateToProps)(OfficeSearch);
